module.exports = __webpack_public_path__ + "static/media/drivendata.c0e06e09.png";